import { useMemo, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { checkKoreanLang, getSessionItem, ENCAR_GLOBAL } from '@encarpkg/shared';
import * as cookie from 'app/libs/cookie';
import { CAR_ID_FROM_DETAIL_TO_REPORT_ACCIDENT, EXPORT_TRANSLATE_GUIDE_CLOSE_REPORT_ACCIDENT_KEY, EXPORT_LEAD_CASE } from 'app/constants/export';
import { setCookieMidnight } from 'app/libs/export/exportTranslateGuide';

const useExportCarReportAccident = () => {
	const { carId } = useParams();

	const [isExportTranslateGuideClosed, setIsExportTranslateGuideClosed] = useState(
		() => !!cookie.getCookie(EXPORT_TRANSLATE_GUIDE_CLOSE_REPORT_ACCIDENT_KEY),
	);

	const isFromExportDetail = useMemo(() => checkKoreanLang() === false && getSessionItem(CAR_ID_FROM_DETAIL_TO_REPORT_ACCIDENT), []);

	const openExportInquiry = useCallback(() => {
		window.location.href = `${ENCAR_GLOBAL}/export-service/inquiry/${carId}?from=${EXPORT_LEAD_CASE.CAR_REPORT_ACCIDENT}`;
	}, [carId]);

	const closeTranslateGuide = useCallback(() => {
		setCookieMidnight(EXPORT_TRANSLATE_GUIDE_CLOSE_REPORT_ACCIDENT_KEY);
		setIsExportTranslateGuideClosed(true);
	}, []);

	return {
		isFromExportDetail,
		isExportTranslateGuideClosed,
		openExportInquiry,
		closeTranslateGuide,
	};
};

export default useExportCarReportAccident;
